import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rise",
  "use": "icon-rise-usage",
  "viewBox": "0 0 9.673 5.39",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.673 5.39\" id=\"icon-rise\">\r\n  <path id=\"icon-rise_路径_1079\" data-name=\"路径 1079\" d=\"M119.476,298.356h8.561a.555.555,0,0,0,.392-.947l-4.281-4.28a.555.555,0,0,0-.785,0l-4.28,4.28a.555.555,0,0,0,.393.947Z\" transform=\"translate(-118.92 -292.966)\" fill=\"#ec212d\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol